import { IPDFTableHeader } from "src/Pages/components/PDF/TableHeader";
import { PDFTableHeader } from "src/Pages/components/PDF/TableHeader/PDFTableHeader";

export const HeadReportParcelasAbertasPDF = () => {
  const dataHeaderPDF: IPDFTableHeader = [
    {
      style: {
        width: "13%",
        textAlign: "left",
        paddingLeft: "8px",
      },
      title: "Operadora",
    },
    {
      style: {
        width: "17%",
        textAlign: "left",
        paddingLeft: "8px",
      },
      title: "Contrato",
    },
    {
      style: {
        width: "18%",
        textAlign: "left",
      },
      title: "Titular/Razão",
    },
    {
      style: {
        width: "12%",
        textAlign: "right",
      },
      title: "D. assinatura",
    },
    {
      style: {
        width: "12%",
        textAlign: "right",
      },
      title: "D. vencimento",
    },
    {
      style: {
        width: "6%",
        textAlign: "center",
      },
      title: "Parc.",
    },
    {
      style: {
        width: "9%",
        textAlign: "right",
      },
      title: "D. recebido",
    },
    {
      style: {
        width: "11%",
        textAlign: "right",
      },
      title: "V. mensalidade",
    },
    {
      style: {
        width: "11%",
        textAlign: "right",
      },
      title: "V. efetuado",
    },

    {
      style: {
        width: "7%",
        textAlign: "right",
      },
      title: "% Corretor",
    },

    {
      style: {
        width: "10%",
        textAlign: "right",
        paddingRight: "8px",
      },
      title: "V. comissão",
    },
  ];

  return <PDFTableHeader data={dataHeaderPDF} />;
};
